<script setup lang="ts">
defineProps<{
  failed?: boolean
  retrying?: boolean
}>()

const emit = defineEmits<{
  retry: []
}>()
</script>

<template>
  <main class="portfolio-loader" aria-live="polite" aria-busy="true">
    <div class="portfolio-loader__content">
      <template v-if="failed">
        <div class="portfolio-loader__status" aria-hidden="true">!</div>
        <p class="portfolio-loader__message">دریافت اطلاعات صفحه انجام نشد.</p>
        <button
          type="button"
          class="portfolio-loader__retry"
          :disabled="retrying"
          @click="emit('retry')"
        >
          {{ retrying ? 'در حال تلاش...' : 'تلاش دوباره' }}
        </button>
      </template>

      <template v-else>
        <div class="portfolio-loader__spinner" aria-hidden="true" />
        <p class="portfolio-loader__message">در حال آماده‌سازی صفحه</p>
      </template>
    </div>
  </main>
</template>

<style scoped>
.portfolio-loader {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: grid;
  min-height: 100dvh;
  place-items: center;
  overflow: hidden;
  padding: 24px;
  color: #25282d;
  background: #f4f5f6;
}

.portfolio-loader__content {
  display: grid;
  width: min(100%, 320px);
  justify-items: center;
  text-align: center;
}

.portfolio-loader__spinner {
  width: 32px;
  height: 32px;
  border: 2px solid #d9dcdf;
  border-top-color: #34383e;
  border-radius: 50%;
  animation: loader-spin 0.8s linear infinite;
}

.portfolio-loader__status {
  display: grid;
  width: 32px;
  height: 32px;
  place-items: center;
  border: 1px solid #b8bcc1;
  border-radius: 50%;
  color: #555a61;
  font-size: 16px;
  font-weight: 700;
}

.portfolio-loader__message {
  margin-top: 16px;
  color: #737981;
  font-size: 13px;
}

.portfolio-loader__retry {
  margin-top: 22px;
  border: 1px solid #c8ccd0;
  border-radius: 6px;
  padding: 10px 18px;
  color: #30343a;
  background: #ffffff;
  font: inherit;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: border-color 0.2s ease, background-color 0.2s ease;
}

.portfolio-loader__retry:hover {
  border-color: #8c9198;
  background: #eceeef;
}

.portfolio-loader__retry:disabled {
  cursor: wait;
  opacity: 0.65;
}

@keyframes loader-spin {
  to { transform: rotate(360deg); }
}

@media (prefers-reduced-motion: reduce) {
  .portfolio-loader__spinner {
    animation-duration: 1.8s;
  }
}
</style>
